import { AxiosInstance } from 'axios'
import { ReturnUpload, ResponseUpload } from '@/types/internalChatAxios'
import { useChatStore } from '@/stores/chat'
import { RequestError } from '@/types/error'

export interface InternalChatServiceInterface {
  send(payload: FormData): Promise<ReturnUpload>;
  sendBase64(payload: FormData): Promise<ReturnUpload>;
  sendFile(payload: FormData): Promise<ReturnUpload>;
  remove(id: number): Promise<void>
}

function upload (httpClient: AxiosInstance): InternalChatServiceInterface {
  async function send (payload: FormData): Promise<ReturnUpload> {
    const chatStore = useChatStore()
    const response = await httpClient.post<ResponseUpload>('/upload', payload, chatStore.config)

    let errors: RequestError | null = null

    if (!response.data) {
      const error = JSON.parse(response.request.response)
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
        message: error.message
      }
    }
    return {
      data: response.data?.data ?? null,
      errors
    }
  }
  //
  async function sendFile (payload: FormData): Promise<ReturnUpload> {
    const chatStore = useChatStore()
    const url = `${process.env.VUE_APP_API_V2}/messages/convert-audio`
    const response = await httpClient.post<ResponseUpload>(url, payload, chatStore.config)

    let errors: RequestError | null = null

    if (!response.data) {
      const error = JSON.parse(response.request.response)
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
        message: error.message
      }
    }
    return {
      data: response.data?.data ?? null,
      errors
    }
  }

  async function sendBase64 (payload: FormData): Promise<ReturnUpload> {
    const chatStore = useChatStore()
    const response = await httpClient.post<ResponseUpload>('/uploadBase64', payload, chatStore.config)

    let errors: RequestError | null = null

    if (!response.data) {
      const error = JSON.parse(response.request.response)
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
        message: error.message
      }
    }
    return {
      data: response.data?.data ?? null,
      errors
    }
  }

  async function remove (id: number): Promise<void> {
    const chatStore = useChatStore()
    const response = await httpClient.delete<ResponseUpload>(`/upload/${id}`, chatStore.config)
    if (response.request.status >= 400) {
        const error = JSON.parse(response.request.response)
        throw error.message
    }
  }

  return {
    send,
    sendFile,
    sendBase64,
    remove
  }
}

export default upload
